import React, {Component} from 'react';
import {Modal} from 'react-bootstrap';

import CoinId from './CoinId.json';


class ChartModal extends Component {
 
componentDidMount(){
    this._isMounted = true;

    this.getSlug();
    
    }

componentDidUpdate(prevProps, prevState) {
   
    if(prevProps.coinName!==this.props.coinName){

       this.getSlug();
    }
}

changeUSD=(event)=>{
  let currency = event.target.value;
		this.setState({
			currency:currency
        },()=>this.getSlug())
}


getSlug(){
    let ID = CoinId.filter(coin => coin.name === this.props.coinName)
    this.setState({coinChart:ID[0].slug},()=>console.log())
}

       
componentWillUnmount(){
  this._isMounted = false;
}


constructor(props,context){
    super(props)
    this.state = {

        loading:true,
        coinChart:[],
        currency:1505
        
    }

  }
  
    render(){

     // let chart=this.showChart()
       
    return( 
      
      <Modal
        {...this.props}
        size="lg"
        height="200px"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        >
        
      <Modal.Header className="modalpie" closeButton>
      <Modal.Title id="contained-modal-title-vcenter">
        <div className="banana3">Price Chart</div>
      </Modal.Title>
      </Modal.Header> 
        
      <Modal.Body> 
        <div>
      <select onChange={this.changeUSD} className="options3">
                    <option className="options" value="1505" key="1">USD</option>
                    <option className="options" value="859" key="2">BTC</option>
    
                  </select>  
         </div> 
                  <div className="chart"><div><iframe src={"https://widget.coinlib.io/widget?type=chart&theme=dark&coin_id="+this.state.coinChart+"&pref_coin_id="+this.state.currency} width="100%" height="536px" scrolling="auto" marginwidth="0" marginheight="0" frameborder="0" border="0" ></iframe></div></div>

        <button  className="cancel2 mt-2" title="Cancel" onClick={this.props.onHide}>Close</button>
      </Modal.Body>
            
      

      </Modal>
      )
    }

}

export default ChartModal;